{
  "learning-path": "Path",
  "learning-path_plural": "Paths",
  "path": "Path",
  "path_plural": "Paths",
  "events": "Events",
  "seminar": "Seminar",
  "seminar_plural": "Seminars",
  "survey": "Survey",
  "webinar": "Webinar",
  "section": "Section",
  "webinar_plural": "Webinars",
  "external": "Campus online",
  "external_plural": "Campus online",
  "user-generated": "Manually added",
  "user-generated_plural": "Manually added",
  "collection": "Collection",
  "collection_plural": "Collections",
  "article": "Article",
  "article_plural": "Articles",
  "practicalAssessment": "Assessment",
  "video": "Video",
  "video_plural": "Videos",
  "resource": "Resource",
  "resource_plural": "Resources",
  "audio": "Audio",
  "audio_plural": "Audio",
  "e-learning": "E-learning",
  "eLearning": "E-learning",
  "e-learning_plural": "E-learning",
  "online-learning": "On-demand learning",
  "onlineLearning": "On-demand learning",
  "online-learning_plural": "On-demand learning",
  "course": "Course",
  "course_plural": "Courses",
  "Course": "Course",
  "learning": "Learning",
  "on-demand": "On-demand",
  "live": "Live",
  "profile": "Assignment group",
  "self-tracked": "Added learning time",
  "type": "Type",
  "other-learning-time": "Other learning time",
  "journey": "Journey",
  "other-learning-time_plural": "Other learning time",
  "live_event": "Live event",
  "liveEvent": "Live event",
  "live-event": "Live event"
}
